import { render, staticRenderFns } from "./ParkedQueue.vue?vue&type=template&id=9c534dda&scoped=true"
import script from "./ParkedQueue.vue?vue&type=script&lang=ts"
export * from "./ParkedQueue.vue?vue&type=script&lang=ts"
import style0 from "./ParkedQueue.vue?vue&type=style&index=0&id=9c534dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c534dda",
  null
  
)

export default component.exports